import { render, staticRenderFns } from "./Starters.vue?vue&type=template&id=1d534f0a"
import script from "./Starters.vue?vue&type=script&lang=js"
export * from "./Starters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports